import React, { useState } from 'react';
import styled from 'styled-components';
import { MovieDisplay } from '../../../utils/Video';
import MovieThumbnail from '../display/MovieThumbnail';
import PlayMovieModal from '../display/PlayMovieModal';
import Api from '../../../utils/Api';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 180px;
    overflow-x: auto;
    box-sizing: border-box;
    padding: 10px;
`;

type Props = {
    movies: MovieDisplay[];
    saveCounter: number;
    setSaveCounter: React.Dispatch<React.SetStateAction<number>>;
};
const MovieThumbnails: React.FC<Props> = ({
    movies,
    saveCounter,
    setSaveCounter,
}) => {
    const [isOpened, setOpened] = useState(false);
    const [movie, setMovie] = useState(movies[0]);
    const handleOpenModal = async (movie: MovieDisplay) => {
        // 最新データを取得
        const allMovies = await Api.fetchCustomerMovies(
            Number(movie.customer_id_or_staff_id),
        );
        const movieDisplays = allMovies.map((m) => new MovieDisplay(m));
        const latestMovie = movieDisplays.find((m) => m.id === movie.id);

        // 更新が必要なデータだけ更新
        movie.playback_position = latestMovie?.playback_position ?? 0;
        setMovie(movie);
        setOpened(true);
    };

    const handleCloseModal = () => {
        setSaveCounter(saveCounter + 1);
        setOpened(false);
    };
    return (
        <Container>
            {movies.map((movie) => (
                <MovieThumbnail
                    key={movie.id}
                    movie={movie}
                    onClick={handleOpenModal}
                />
            ))}
            {movies.length > 0 && (
                <PlayMovieModal
                    isOpened={isOpened}
                    movie={movie}
                    movies={movies}
                    onClose={handleCloseModal}
                />
            )}
        </Container>
    );
};

export default MovieThumbnails;
